const actions = {
  SET_STATE: 'user/SET_STATE',
  LOGIN: 'user/LOGIN',
  REGISTER: 'user/REGISTER',
  LOAD_CURRENT_ACCOUNT: 'user/LOAD_CURRENT_ACCOUNT',
  LOGOUT: 'user/LOGOUT',
  RESET: 'user/RESET',
  ON_BOARDING_DONE: 'user/ON_BOARDING_DONE',
  CONFIRMATION_EMAIL: 'user/CONFIRMATION_EMAIL',
  SEND_CONFIRMATION_EMAIL: 'user/SEND_CONFIRMATION_EMAIL',
}

export default actions
